export var PIPES_DOCUMENT = {};
